import {BookingMutationActionBase} from "../booking-mutation-action-base";
import {
    IDotRezPartialBookingSessionData
} from "../../../../dot-rez-api/data-contracts/booking/dot-rez-booking-session-data.interface";

export class RetrieveSsrsAvailabilityMutation extends BookingMutationActionBase {

    _runMutation(): Promise<IDotRezPartialBookingSessionData> {
        return this.session.bookingStateQueryBuilder().useSsrsAvailability().getBookingState();
    }

    get willAffectTotal(): boolean {
        return false;
    }
}
